import script from "./booking.vue?vue&type=script&setup=true&lang=js"
export * from "./booking.vue?vue&type=script&setup=true&lang=js"

import "./booking.vue?vue&type=style&index=0&id=6af509ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af509ac"]])

export default __exports__